import React, { useEffect, useState, useRef } from "react";
import {
  Offcanvas,
  Card,
  Container,
  Row,
  Form,
  Toast,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import api from "../../../seller-apis/api";
import {
  approvedOrProducts,
  approvedProducts,
  actionRequiredFilter,
  getVPriceReqsFilter,
} from "../../../seller-apis/apidataField";
// import ProductCard from "../../common/ProductCard";
import ProductCardNewDesign from "../../common/ProductCardNewDesign";
import Popup from "../../common/Popup";
import UpdtProPopup2 from "../../common/UpdtProPopup2";
import "../../inventry.css";
import { useAlert } from "react-alert";
import { NavLink, useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Actions } from "../../../Actions/Actions";
import { variables } from "../../../Variables.json";
import PaginationNew from "../../common/Pagination";
import ProductSKUSearch from "../../common/ProductSearch/ProductSKUSearch";
import BulkStockHandler from "../../common/BulkStockHandler";
import NewPriceReqPopup from "../../common/NewPriceReqPopup";
import { saveVendorStock } from "../../../services/vendor.service";
import RejectPriceResubmit from "../../common/RejectPriceResubmit";

import PriceSortDropdown from "./Pricesortdropdown";
import '../../../assets/css/productCardNewDesign.css';

var globalFilter = {
  pageNo:1,
  size: 12,
  filter:{
      status: "V_PENDING"
  },
  from: "latestVpriceReq"
};

const getActivePurchasePrice = (product) => {
  if (product?.vendors?.[0]?.combination && product.vendors[0].combination.length > 0) {
    const activeCombination = product.vendors[0].combination.find(
      combo => (combo.vActive === "ACTIVE" || combo.vActive === "INACTIVE_REQ") && 
               combo.stock > 0 && 
               combo.purchase_price
    );
    
    if (activeCombination) {
      return activeCombination.purchase_price;
    }
    
    const firstCombo = product.vendors[0].combination.find(combo => combo.purchase_price);
    if (firstCombo) {
      return firstCombo.purchase_price;
    }
  }
  
  return product?.vendors?.[0]?.purchase_price || 0;
};

/**
 * Sort products by price (client-side)
 */
const sortProductsByPrice = (products, order) => {
  if (!order) return products;
  
  return [...products].sort((a, b) => {
    const priceA = getActivePurchasePrice(a);
    const priceB = getActivePurchasePrice(b);
    
    return order === 'asc' ? priceA - priceB : priceB - priceA;
  });
};


function PriceChangeRequest() {
  var outerdiv;
  var loaderDiv;

  const alert = useAlert();
  const history = useHistory();
  const dispatch = useDispatch();

  /** True when no user-applied filters (search, HSN, etc.) are active */
  const isNoFilterApplied = () =>
    (!globalFilter.filters || Object.keys(globalFilter.filters).length === 0) &&
    !globalFilter.hsnFilter;

  // Size states
  const updateSearchCountRef = useRef(null);

  const [currView, setcurrView] = useState();
  const [approvedProductsList, setapprovedProductsList] = useState([]);
  const [appRecords, setappRecords] = useState();

  // Pagination related

  const [selectedPage, setselectedPage] = useState(1);
  const [compforPaginationweb, setcompforPaginationweb] =
    useState("approvedPro");

  // Popup related states

  const [updtProVisibility, setupdtProVisibility] = useState(false);
  const [clickedUpdateNo, setCickedUpdateNo] = useState();
  const [selectedProductPopup, setselectedProductPopup] = useState();
  const [selectedImgPopup, setselectedImgPopup] = useState();
  const [updtPopuprel, setupdtPopuprel] = useState([]);

  // Confirmation Related States

  const [confirmationState, setconfirmationState] = useState(false);
  const [msgConfirmation, setmsgConfirmation] = useState();
  const [selectedProduct, setselectedProduct] = useState();
  const [selectedId, setselectedId] = useState();
  const [activDeactiveState, setactivDeactiveState] = useState();
  const [deactiveReason, setdeactiveReason] = useState(false);
  // Alert related states

  const [alertshow, setalertShow] = useState(false);
  const [alertMessage, setalertMessage] = useState();
  const [alertType, setalertType] = useState();

  // Loader state

  const [loaderProduct, setloaderProduct] = useState("block");
  // Popup related

  const [isPopupVisible, setisPopupVisible] = useState("block");
  const [isPopupVisiblePendfapp, setisPopupVisiblePendfapp] = useState("block");

  const [productNo, setproductNo] = useState(0);

  // Toast

  const [showToast, setshowToast] = useState(false);
  const [ToastMsg, setToastMsg] = useState();
  // Combination related

  const [combAttri, setcombAttri] = useState([]);
  const [currentProupdt, setcurrentProupdt] = useState();

  // Detail popup

  const [currDetail, setcurrDetail] = useState(0);
  const [currDetailPend, setcurrDetailPend] = useState(0);

  // Web search

  const [searchPro, setsearchPro] = useState();
  const [searchType, setSearchType] = useState("Product Name");

  const [isTabCheck, setisTabCheck] = useState();

  // Verify transfer price

  const [offcanshow, setoffcanshow] = useState(false);
  const [offcanstate, setoffcanstate] = useState("ask");
  const [newoffcanPrice, setnewoffcanPrice] = useState();
  const [seloption, setseloption] = useState("continueSame");
  const [curroffCanPrice, setcurroffCanPrice] = useState();
  const [offcanspcl, setoffcanspcl] = useState();
  const [offcancurrId, setoffcancurrId] = useState();
  const [taxClass, settaxClass] = useState();

  // Lowest price

  const [lowestPrice, setlowestPrice] = useState(undefined);

  // Filter State
  const [currstatussort, setcurrstatussort] = useState("Status*");
  const [currpricesort, setcurrpricesort] = useState("Status*");

  const [removeFilterClass, setremoveFilterClass] = useState(
    "invent_remove_filter_btn"
  );
  const searchParam = {

    /*"vendors": {
      "$elemMatch": {
        "$or": [
          {
            "$and": [
              {
                "vActive": {
                  "$exists": true
                }
              },
              {
                "vActive": {
                  "$ne": "REJECT"
                }
              },
              {
                "active": false
              }
            ]
          },
          {
            "$and": [
              {
                "vActive": {
                  "$exists": true
                }
              },
              {
                "vActive": {
                  "$ne": "REJECT"
                }
              },
              {
                "$or": [
                  {
                    "prSts": "V_PENDING"
                  },
                  {
                    "prSts": {
                      "$exists": false
                    }
                  }
                ]
              }
            ]
          },
          {
            "$and": [
              {
                "vActive": {
                  "$exists": true
                }
              },
              {
                "vActive": {
                  "$ne": "REJECT"
                }
              },
              {
                "$or": [
                  {
                    "sellerWeightChangeSts": "V_PENDING"
                  },
                  {
                    "combination.sellerWeightChangeSts": "V_PENDING"
                  }
                ]
              }
            ]
          }
        ]
      }
    }*/

  };
  //SL-675
  const [totalRcordId, setTotalReordId] = useState([]);
  const [resetSearchType, setResetSearchType] = useState(0);

  // SL-906
  const [newPricePopupShow, setNewPricePopupShow] = useState(false);
  const [curPricePopupLead, setCurPricePopupLead] = useState(false);
  const [curPricePopupUrl, setCurPricePopupUrl] = useState(false);
  const [curPricePopupPrice, setCurPricePopupPrice] = useState(false);
  const [curPricePopupGst, setCurPricePopupGst] = useState(false);
  const [curPricePopupCombState, setCurPricePopupCombState] = useState(false);
  const [priceSortOrder, setPriceSortOrder] = useState(null); // null, 'asc', or 'desc'
  const [selectedIds, setSelectedIds] = useState([]);
  const [showPriceOfferPopup, setShowPriceOfferPopup] = useState(false);
  const [selectedProductData, setSelectedProductData] = useState(null);
  const handleSelectAll = (checked) => {
    if (checked) {
      // Select all 10 items on current page
      const pageIds = approvedProductsList.map(item => item._id);

      setSelectedIds(pageIds);
    } else {
      // Unselect all
      setSelectedIds([]);
    }
  };

  const handleSelectItem = (id, checked) => {
    setSelectedIds(prev =>
      checked
        ? [...prev, id]
        : prev.filter(item => item !== id)
    );
  };

  useEffect(() => {
    // clear product filter
    if (globalFilter['product']){
      delete globalFilter['product'];
    }
    getProducts(1);
  }, []);

  /**
   * Get the Products
   */
  const getProducts = (pageNo) => {
    setisTabCheck(true);
    setselectedPage(pageNo);
    globalFilter.pageNo = pageNo;
    let size = window.innerWidth;
    if (size > 768) {
      setcurrView("laptop");
    } else {
      setcurrView("mobile");
    }
    api.product
      .vPriceReqRetrieveAll(getVPriceReqsFilter(globalFilter))
      .then((res) => {
      //   const sortedProducts = priceSortOrder 
      // ? sortProductsByPrice(res.products, priceSortOrder)
      // : res.products;
    
      //   setapprovedProductsList(sortedProducts);
      //   setappRecords(res.totalRecords);
      //   Actions.InventoryCountUpdateAction(dispatch, { actionRequired: res.totalRecords });
      //   if (res.totalRecords === 0 && isNoFilterApplied()) {
      //     setloaderProduct("none");
      //     history.replace("/my-inventory/approved/all-products");
      //     return;
      //   }
        // if (totalRcordId.length == 0) {//SL-675
        //   setTotalReordId(res?.productId);
        // }
        setTotalReordId(res?.productId);
        setapprovedProductsList(res.data);
        setappRecords(res.totalRecords);
        setloaderProduct("none");
        removeLoader();
      })
      .catch((err) => {
        setloaderProduct("none");
        console.log(err);
      });
  }

  const togglePriceSort = () => {
  let newSortOrder = priceSortOrder === null ? 'asc' : 
                     priceSortOrder === 'asc' ? 'desc' : 'asc';
  setPriceSortOrder(newSortOrder);
  
  // Apply immediately (no API call)
  const sortedProducts = sortProductsByPrice(approvedProductsList, newSortOrder);
  setapprovedProductsList(sortedProducts);
}

  const clearPriceSort = () => {
    setPriceSortOrder(null);
    applyLoader();
    globalFilter.pageNo = selectedPage;
    
    api.product
      .productsRetrieveall(actionRequiredFilter(globalFilter))
      .then((res) => {
        const sortedProducts = priceSortOrder 
      ? sortProductsByPrice(res.products, priceSortOrder)
      : res.products;
    
        setapprovedProductsList(sortedProducts);
        setappRecords(res.totalRecords);
        removeLoader();
      });
  }

  // function productCheck(e) {
  //   setcombAttri([]);
  //   for (let i = 0; i < approvedProductsList.length; i++) {
  //     let baseImg;
  //     if (approvedProductsList[i]._id === e) {
  //       console.log(approvedProductsList[i]);
  //       setselectedProductPopup(approvedProductsList[i].productName);
  //       if (approvedProductsList[i].attributeList) {
  //         if (approvedProductsList[i].attributeList.length > 0) {
  //           setcombAttri(approvedProductsList[i].attributeList);
  //           setcurrentProupdt(approvedProductsList[i]);
  //         }
  //       }
  //       setupdtPopuprel({
  //         SKU: approvedProductsList[i].SKU,
  //         price: approvedProductsList[i].vendors[0].purchase_price,
  //       });
  //       approvedProductsList[i].images.map((item) => {
  //         if (item.baseImage === true) {
  //           if (item.image.startsWith("products")) {
  //             baseImg = item.image;
  //             setselectedImgPopup(baseImg);
  //           } else {
  //             let img = item.image.substr("41");
  //             baseImg = img;
  //             setselectedImgPopup(baseImg);
  //           }
  //         }
  //       });

  //       setCickedUpdateNo(e);
  //       setupdtProVisibility(true);
  //     }
  //   }
  // }

  function checkpopupvisibility(e) {
    if (e === false) {
      setupdtProVisibility(false);
    } else {
      setupdtProVisibility(true);
    }
  }
  // Pagination function
  function paginate(data) {
    applyLoader();
    setproductNo(0);
    setcurrDetail(0);
    // globalFilter.pageNo = data.number;
    // setselectedPage(data.number);
    getProducts(data.number);
    // Approved Products
    // api.product
    //   //SL-968
    //   //.productsRetrieveall(approvedOrProducts(globalFilter))
    //   .productsRetrieveall(actionRequiredFilter(globalFilter))
    //   .then((res) => {
    //     const sortedProducts = priceSortOrder 
    //   ? sortProductsByPrice(res.products, priceSortOrder)
    //   : res.products;
    
    //     setapprovedProductsList(sortedProducts);        
    //     setappRecords(res.totalRecords); // Replace totalRecords with totalRecords from productsRetrieveall API
    //     removeLoader();
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //     removeLoader();
    //   });
  }

  const handleUpdatePriceReq = async(vPriceReqId, productId, newPrice, prSts, url) => {
      applyLoader();
      const data = {
        _id: vPriceReqId,
        product: productId,
        status: prSts,
        price: newPrice,
      };
      if (url) {
        data['url'] = url;
      }

      api.transferprice.updatePriceRequest(data).then((res) => {
        if (res.message === "price change request submitted" || res.message === "price request updated") {
          if (prSts === "V_ACTIVE") {
            alert.success('Price offer accepted successfully!');
          } else {
            alert.info('Price offer rejected!');
          }
        }
        getProducts(1);
      }).catch((err) => {
        removeLoader();
        alert.error('Error Updating price request');
      });
  }

  const handleUpdatePriceBulkReq = async(prSts) => {
      applyLoader();
      const data = {
        prIds: selectedIds,
        status: prSts
      };

      api.transferprice.updatePriceBulkRequests(data).then((res) => {
        if (res.message === "price request updated") {
          if (prSts === "V_ACTIVE") {
            alert.success('Price offer accepted successfully!');
          } else {
            alert.info('Price offer rejected!');
          }
        }
        getProducts(1);
        setSelectedIds([]);
      }).catch((err) => {
        removeLoader();
        alert.error('Error Updating price request');
      });
  }

  const handleNewPriceSubmit = async (vPriceReqId, productId, newPrice, stockValue, url) => {
    applyLoader();
    // data to reject current request
    const vRejectData = {
      _id: vPriceReqId,
      product: productId,
      status: "V_REJECT",
      price: newPrice,
    };

    // new price request data
    const data = {
      product: productId,
      price: newPrice
    };

    if (url) {
      data.url = url;
      vRejectData.url = url;
    }

    // Reject the old request
    api.transferprice.updatePriceRequest(vRejectData).then((res) => {
      // submit new price request
      api.transferprice.priceChangeRquest(data).then(async(res) => {
        if (res.message === "price change request submitted" || res.message === "price request updated") {
          alert.success('New price request successfully sent to Toolsvilla');
          //  await closeNotificationAndRefresh('price');
          //   checkShouldStockUpdate(stockValue, combination)
          // Remove the rejected combination from selectedOfferData
          // if (selectedOfferData.combinations && selectedOfferData.combinations.length > 0) {
          //   const originalCount = selectedOfferData.combinations.length;
          //   const rejectedUrl = combination?.url;
          //   const remainingCombinations = selectedOfferData.combinations.filter(comb =>
          //     comb.url !== rejectedUrl
          //   );
          //   const remainingCount = remainingCombinations.length;

          //   if (remainingCombinations.length > 0) {
          //     setSelectedOfferData(prev => ({
          //       ...prev,
          //       combinations: remainingCombinations
          //     }));
          //   } else {
          //     refreshProducts()

          //   }
          // } else {
          //   console.log('Single product processed, closing popup');
          //   refreshProducts()
          // }
          getProducts(1);
        } else {
          alert.info(res.message);
          getProducts(1);
        }
      }).catch((err) => {
        console.log('API error:', err);
        alert.error('Error submitting new price request');
        removeLoader();
      });
    }).catch((err) => {
      removeLoader();
      alert.error('Error Updating price request');
    });
  };

  const handleOnReject = (data) => {
    setShowPriceOfferPopup(true);
    setSelectedProductData(data);
  }

  // apply loaders
  function applyLoader() {
    outerdiv = document.getElementById("orDeskContain");
    loaderDiv = document.getElementById("enNewLoader");
    loaderDiv.classList.add("loader-bt");
    setloaderProduct("flex");
    outerdiv.classList.add("div-bk");
  }

  // remove loader

  function removeLoader() {
    loaderDiv.classList.remove("loader-bt");
    setloaderProduct("none");
    outerdiv.classList.remove("div-bk");
  }

  // search product btn web

  function searchProdBtnweb() {
    if (searchPro !== undefined && searchPro !== "") {
      globalFilter.filters = {
        ...globalFilter.filters,
        productName: searchPro,
      };
      applyLoader();
      setselectedPage(1);
      setcompforPaginationweb("appsearchPro");
      globalFilter.pageNo = "1";
      api.product
        //SL-968
        //.productsRetrieveall(approvedProducts(globalFilter))
        .productsRetrieveall(actionRequiredFilter(globalFilter))
        .then((res) => {
          
          const sortedProducts = priceSortOrder 
      ? sortProductsByPrice(res.products, priceSortOrder)
      : res.products;
    
        setapprovedProductsList(sortedProducts);

          setremoveFilterClass("invent_remove_filter_btn_active");
          setappRecords(res.totalRecords);
          removeLoader();
        })
        .catch((err) => {
          console.log(err);
          removeLoader();
        });
    } else if (compforPaginationweb !== "approvedPro") {
      applyLoader();
      globalFilter.pageNo = "1";
      outerdiv.classList.add("div-bk");
      loaderDiv.classList.add("loader-bt");
      globalFilter.filters = {};
      setselectedPage(1);
      api.product
        //SL-968
        //.productsRetrieveall(approvedOrProducts(globalFilter))
        .productsRetrieveall(actionRequiredFilter(globalFilter))
        .then((res) => {
          if (currstatussort === "Status*" && currpricesort === "Status*") {
            setremoveFilterClass("invent_remove_filter_btn");
          } else {
            setremoveFilterClass("invent_remove_filter_btn_active");
          }
          setcompforPaginationweb("approvedPro");
          removeLoader();
          const sortedProducts = priceSortOrder 
      ? sortProductsByPrice(res.products, priceSortOrder)
      : res.products;
    
        setapprovedProductsList(sortedProducts);
          setappRecords(res.totalRecords);
        })
        .catch((err) => console.log(err));
      removeLoader();
    }
  }

  // Toggle

  // function changeproductStatus(id, status) {
  //   let quantity;
  //   for (let i = 0; i < approvedProductsList.length; i++) {
  //     if (approvedProductsList[i]._id === id) {
  //       setselectedProduct(approvedProductsList[i].productName);
  //       quantity = approvedProductsList[i].vendors[0].stock;
  //     }
  //   }
  //   if (status === "on") {
  //     setdeactiveReason(false);
  //     // if (quantity === 0) {
  //     //   setToastMsg("Please update stock to activate product.");
  //     //   setshowToast(true)
  //     // }
  //     // else {
  //     setactivDeactiveState("activate");
  //     setselectedId(id);
  //     setmsgConfirmation("Are you sure you want to activate this product");
  //     setconfirmationState(true);
  //     // }
  //   } else if (status === "off") {
  //     console.log("jhfvhge");
  //     setdeactiveReason(true);
  //     setactivDeactiveState("deactivate");
  //     setselectedId(id);
  //     setmsgConfirmation("Are you sure you want to deactivate this product");
  //     setconfirmationState(true);
  //   }
  // }

  // Update response

  function callbackResUpdate(res) {
    if (res === "product updated") {
      applyLoader();
      setapprovedProductsList([])
      api.product
        //SL-968
        //.productsRetrieveall(approvedOrProducts(globalFilter))
        .productsRetrieveall(actionRequiredFilter(globalFilter))
        .then((apiRes) => {
          setappRecords(apiRes.totalRecords);
          Actions.InventoryCountUpdateAction(dispatch, { actionRequired: apiRes.totalRecords });
          if (apiRes.totalRecords === 0 && isNoFilterApplied()) {
            removeLoader();
            setupdtProVisibility(false);
            history.replace("/my-inventory/approved/all-products");
            return;
          }
          if (apiRes.totalRecords > 0) {
            const sortedProducts = priceSortOrder
              ? sortProductsByPrice(apiRes.products, priceSortOrder)
              : apiRes.products;
            setapprovedProductsList(sortedProducts);
          }
          removeLoader();
          alert.success("Product updated");
          setupdtProVisibility(false);
        })
        .catch((err) => {
          console.log(err);
          removeLoader();
        });
    } else {
      alert.error("Failed to update");
      setupdtProVisibility(false);
    }
  }

  //  Control view acc to size
  function handleResize() {
    if (window.innerWidth > 700) {
      setcurrView("laptop");
    } else {
      setcurrView("mobile");
    }
  }

  window.addEventListener("resize", handleResize);

  //   Popup related functions

  function setpopupVisibility(e, from) {
    console.log(e);
    if (from) {
      if (e > -1) {
        console.log(e);
        console.log(e);
        setcurrDetailPend(e);
        setisPopupVisiblePendfapp("block");
      } else {
        console.log(e);
        setisPopupVisiblePendfapp("none");
        setisPopupVisible("none");
      }
    } else {
      if (e > -1) {
        console.log(e);
        setcurrDetail(e);
        setisPopupVisible("block");
      } else {
        console.log(e);
        setisPopupVisible("none");
        setisPopupVisiblePendfapp("none");
      }
    }
  }

  function henfun(e) {
    setproductNo(0);

    setproductNo(e);
  }

  // Search on enter web

  function checkevent(e) {
    if (e.keyCode === 13) {
      //SL-696
      let filterProduct = {
        "pageNo": 1,
        "size": 12,
        "filter": {}
      }
      let outerdiv = document.getElementById("orDeskContain");
      let loaderDiv = document.getElementById("enNewLoader");

      if (searchPro !== "" && searchPro !== undefined) {
        console.log("searchPro: ", searchPro);
        let ordersearchFilter = searchType != 'sku' ? { "_id-objectId": searchPro } : { "_id-objectId": searchPro };
        filterProduct.filter = {
          ...ordersearchFilter,
        }
        outerdiv.classList.add("div-bk");
        loaderDiv.classList.add("loader-bt");
        setloaderProduct("block");
        setselectedPage(1);
        globalFilter.pageNo = "1"

        setcompforPaginationweb("appsearchPro");
        api.product
          .productsRetrieveall(filterProduct)
          .then((res) => {
            setremoveFilterClass("invent_remove_filter_btn_active");
            setapprovedProductsList(res.products);
            setappRecords(res.totalRecords);
            outerdiv.classList.remove("div-bk");
            setloaderProduct("none");
            loaderDiv.classList.remove("loader-bt");
          })
          .catch((err) => {
            outerdiv.classList.remove("div-bk");
            loaderDiv.classList.remove("loader-bt");
            console.log(err);
            setloaderProduct("none");
          });
      } else if (compforPaginationweb !== "approvedPro") {
        globalFilter.filters = {};
        setloaderProduct("block");
        outerdiv.classList.add("div-bk");
        loaderDiv.classList.add("loader-bt");
        setselectedPage(1);
        globalFilter.pageNo = "1"

        setcompforPaginationweb("approvedPro");
        api.product
          //SL-968
          //.productsRetrieveall(approvedOrProducts(globalFilter))
          .vPriceReqRetrieveAll(actionRequiredFilter(globalFilter))
          .then((res) => {
            if (currstatussort === "Status*" && currpricesort === "Status*") {
              setremoveFilterClass("invent_remove_filter_btn");
            } else {
              setremoveFilterClass("invent_remove_filter_btn_active");
            }
            outerdiv.classList.remove("div-bk");
            loaderDiv.classList.remove("loader-bt");
            // console.log(res);
            // const sortedProducts = priceSortOrder 
            // ? sortProductsByPrice(res.products, priceSortOrder)
            // : res.products;
          
            setapprovedProductsList(res.data);
        
            setappRecords(res.totalRecords);
            setloaderProduct("none");
          })
          .catch((err) => console.log(err));
        outerdiv.classList.remove("div-bk");
        loaderDiv.classList.remove("loader-bt");
        setloaderProduct("none");
      }
    }
  }

  // Offcanvas show/hide
  const handleCloseoffcan = () => {
    setnewoffcanPrice();
    setoffcanshow(false);
    setoffcanstate("ask");
  };
  const handleopenoffcan = () => setoffcanshow(true);

  // Off canvas ask new price

  const checkNewPrice = () => {
    if (
      newoffcanPrice === undefined ||
      newoffcanPrice === "" ||
      newoffcanPrice < 1
    ) {
      alert.info("Please enter a valid new price.");
    } else {
      setoffcanstate("jhdf");
    }
  };

  // New price request fun offcanvas 2 state

  const newPriceReq = () => {
    document.getElementById("sub_newreq").disabled = true;
    console.log(document.getElementById("sub_newreq").disabled);
    if (seloption === undefined || seloption === "") {
      alert.info("Please select one option");
      document.getElementById("sub_newreq").disabled = false;
    } else {
      handleCloseoffcan();
      // console.log(selectedId)
      if (seloption === "continueSame") {
        let data = {
          prInActive: false,
          product: offcancurrId,
          price: newoffcanPrice,
        };
        api.transferprice
          .priceChangeRquest(data)
          .then((res) => {
            if (res.message === "price change request submitted") {
              alert.success(
                "New price request successfully sent to Toolsvilla"
              );
              alert.success("Transfer Price verified");
              let filter = {
                pageNo: "1",
              };
              setselectedPage(1);
              globalFilter.pageNo = "1"
              // Approved Products
              api.product
                //SL-968
                //.productsRetrieveall(approvedOrProducts(globalFilter))
                .productsRetrieveall(actionRequiredFilter(globalFilter))
                .then((res) => {
                  console.log(res);
                  const sortedProducts = priceSortOrder 
      ? sortProductsByPrice(res.products, priceSortOrder)
      : res.products;
    
        setapprovedProductsList(sortedProducts);
        
                  setappRecords(res.totalRecords);
                })
                .catch((err) => console.log(err));
            } else {
              alert.info(res.message);
            }
          })
          .catch((err) => console.log(err));
      } else {
        let data = {
          prInActive: true,
          product: offcancurrId,
          price: newoffcanPrice,
        };
        api.transferprice
          .priceChangeRquest(data)
          .then((res) => {
            if (res.message === "price change request submitted") {
              alert.success(
                "New price request successfully sent to Toolsvilla"
              );
              alert.success("Transfer Price verified");
              let filter = {
                pageNo: "1",
              };
              setselectedPage(1);
              globalFilter.pageNo = "1"
              // Approved Products
              api.product
                //SL-968
                //.productsRetrieveall(approvedOrProducts(globalFilter))
                .productsRetrieveall(actionRequiredFilter(globalFilter))
                .then((res) => {
                  console.log(res);
                  const sortedProducts = priceSortOrder 
                  ? sortProductsByPrice(res.products, priceSortOrder)
                  : res.products;
                
                    setapprovedProductsList(sortedProducts);
                  setappRecords(res.totalRecords);
                })
                .catch((err) => console.log(err));
            } else {
              alert.info(res.message);
            }
            handleCloseoffcan();
          })
          .catch((err) => console.log(err));
      }
      document.getElementById("sub_newreq").disabled = false;
    }
  };

  // Verify transfer price after 1 popup

  function noVerifyPrice() {
    setoffcanstate("askNewPrice");
  }

  function yesVerifyPrice() {
    if (offcanspcl === "oldPros") {
      let data = {
        _id: offcancurrId,
        purchase_price: curroffCanPrice,
        prSts: "V_ACTIVE",
      };
      api.product
        .addToExProduct(data)
        .then((res) => {
          console.log(res);
          if (res.message === "product updated") {
            alert.success("Transfer Price verified");
            let filter = {
              pageNo: "1",
            };
            setselectedPage(1);
            globalFilter.pageNo = "1";
            // Approved Products
            api.product
              //SL-968
              //.productsRetrieveall(approvedOrProducts(globalFilter))
              .productsRetrieveall(actionRequiredFilter(globalFilter))
              .then((res) => {
                console.log(res);
                const sortedProducts = priceSortOrder 
      ? sortProductsByPrice(res.products, priceSortOrder)
      : res.products;
    
        setapprovedProductsList(sortedProducts);
                setappRecords(res.totalRecords);
                handleCloseoffcan();
              })
              .catch((err) => console.log(err));
          } else {
            alert.info("Error");
          }
        })
        .catch((err) => console.log(err));
    } else {
      let data = {
        product: offcancurrId,
        purchase_price: curroffCanPrice,
        status: "V_ACTIVE",
      };
      api.transferprice
        .updatePriceRequest(data)
        .then((res) => console.log(res))
        .catch((err) => console.log(err));
    }
  }

  // Verfiy Transfer Price

  const verifyTransferPrice = (id, price, spcl, lowestPrice, taxCs) => {
    console.log(price);
    console.log(id, spcl);
    setoffcancurrId(id);
    setcurroffCanPrice(price);
    setoffcanspcl(spcl);
    setlowestPrice(lowestPrice);
    settaxClass(taxCs);
    handleopenoffcan();
  };

  // Function to close all popups opened

  document.onkeydown = function (evt) {
    evt = evt || window.event;
    if (evt.key === "Esc" || evt.key === "Escape") {
      setisPopupVisible("none");
      setupdtProVisibility(false);
      setoffcanshow(false);
      setisPopupVisiblePendfapp("none");
    }
  };

  // Clear Filters

  function clearFilters() {
    if (
      globalFilter.filters ||
      globalFilter.prSts ||
      //globalFilter.status ||
      globalFilter.prStatus
    ) {
      applyLoader();
      setselectedPage(1);
      globalFilter = {
        pageNo: 1,
        prStatus: {
          $or: [
            {
              //SL-968
              //prSts: "V_PENDING",
              $and: [
                //{ combination: { $exists: false, $size: 0  } },
                {
                  $or: [
                    { combination: { $exists: false } },
                    { combination: { $size: 0 } }
                  ]
                },
                { prSts: "V_PENDING" }
              ]
            },
            {
              combination: {
                $elemMatch: {
                  purchase_price: { $exists: true, $ne: null },
                  prSts: "V_PENDING"
                }
              }
              /*$and : [
                { combination: { $exists: true, $ne: [] } },
                { "combination.purchase_price" : { $exists: true, $ne: null }},
                { "combination.prSts": "V_PENDING" },
              ]*/
            },
          ],
        },
        //No need to show products vendor's active = false | Ticket : SL-968
        /*status: {
          active: false,
        },*/
      };
      setcurrpricesort("Status*");
      setcurrstatussort("Status*");
      setsearchPro("");
      api.product
        //SL-968
        //.productsRetrieveall(approvedProducts(globalFilter))
        .productsRetrieveall(actionRequiredFilter(globalFilter))
        .then((res) => {
          setremoveFilterClass("invent_remove_filter_btn");
          const sortedProducts = priceSortOrder
            ? sortProductsByPrice(res.products, priceSortOrder)
            : res.products;
          setapprovedProductsList(sortedProducts);
          setappRecords(res.totalRecords);
          if (res.totalRecords === 0 && isNoFilterApplied()) {
            Actions.InventoryCountUpdateAction(dispatch, { actionRequired: 0 });
            removeLoader();
            history.replace("/my-inventory/approved/all-products");
            return;
          }
          if (res.totalRecords < 1) {
            alert.info("No Records Found");
          }
          removeLoader();
        })
        .catch((err) => console.log(err));
    }
  }
  const filterSearch = (data) => {
    console.log("search data: ", data);
    //setsearchPro(data.data);
    //setSearchType(data.type)
    globalFilter['product'] = {$in: data.data};
    if (globalFilter?.searchIds)
      delete globalFilter['searchIds'];
    globalFilter.pageNo = 1;
    getProducts(1);
    //SL-968
    //api.product.productsRetrieveall(approvedOrProducts(globalFilter))
    // api.product.vPriceReqRetrieveAll(actionRequiredFilter(globalFilter))
    //   .then((res) => {
    //     const sortedProducts = priceSortOrder
    //       ? sortProductsByPrice(res.products, priceSortOrder)
    //       : res.products;
    //     setapprovedProductsList(sortedProducts);
    //     setappRecords(res.totalRecords);
    //     setloaderProduct("none");
    //   })
    //   .catch((err) => {
    //     setloaderProduct("none");
    //     console.log(err);
    //   });
    // if (globalFilter?.filters && globalFilter['filters']['_id-objectId'])
    //   delete globalFilter['filters']['_id-objectId'];

  }

  // useEffect(() => {
  //   checkevent({ "keyCode": 13 }, "appPro");
  // }, [searchPro])



  //<Start-Here> Search Issue Ticket: SL-696
  const gotoCurrentPage = () => {
    applyLoader();
    setsearchPro("");
    const globalFilter = {
      pageNo: selectedPage,
      prStatus: {
        $or: [
          {
            //SL-968
            //prSts: "V_PENDING",
            $and: [
              //{ combination: { $exists: false, $size: 0  } },
              {
                $or: [
                  { combination: { $exists: false } },
                  { combination: { $size: 0 } }
                ]
              },
              { prSts: "V_PENDING" }
            ]
          },
          {
            combination: {
              $elemMatch: {
                purchase_price: { $exists: true, $ne: null },
                prSts: "V_PENDING"
              }
            }
            /*$and : [
              { combination: { $exists: true, $ne: [] } },
              { "combination.purchase_price" : { $exists: true, $ne: null }},
              { "combination.prSts": "V_PENDING" },
            ]*/
          },
        ],
      },
      //No need to show products in which vendor's active = false | Ticket : SL-968
      /*status: {
        active: false,
      },*/
      //Need to remove products in which weight verification is pending | Ticket : SL-968
      /*weightStatus: {
        $or: [
          {
            sellerWeightChangeSts: "V_PENDING",
          },
          {
            "combination.sellerWeightChangeSts": "V_PENDING",
          },
        ],
      },*/
    };

    // Approved Products
    api.product
      //SL-968
      //.productsRetrieveall(approvedOrProducts(globalFilter))
      .productsRetrieveall(actionRequiredFilter(globalFilter))
      .then((res) => {
        const sortedProducts = priceSortOrder
          ? sortProductsByPrice(res.products, priceSortOrder)
          : res.products;
        setapprovedProductsList(sortedProducts);
        setappRecords(res.totalRecords);
        removeLoader();
      })
      .catch((err) => {
        console.log(err);
        removeLoader();
      });
  }
  //</End-Here> Search Issue Ticket: SL-696


  //SL-699 : Seller Stock Update
  async function updateSellerStock(id, stock, url, index, combination, noRefresh) {
    let sitePrice;

    let data = {
      "_id": id,
      "stock": stock,
      "vActive": "ACTIVE",
      "reason": ""
    }
    let addToExData = {
      "_id": id,
    }
    let combTemp = {
      "stock": stock,
      "vActive": "ACTIVE",
      "reason": ""
    }
    //if given 0, then out of stock
    if (stock == 0) {
      data["vActive"] = "INACTIVE";
      data["reason"] = "Out Of Stock";
      combTemp["vActive"] = "INACTIVE";
      combTemp["reason"] = "Out Of Stock";
    }

    try {
      if (url !== undefined && url !== null) {
        data["url"] = url;
        combTemp["url"] = url;
        addToExData["combination"] = combTemp;
        sitePrice = combination?.sitePrice;
        if ((Number(combination?.stock) || 0) < 1 && stock > 0) {
          await handleSaveVendorStock(id, stock, url, index, combination, "In Stock", combination?.price, sitePrice);
        }
        else if (Number(stock) === 0) {
          await handleSaveVendorStock(id, stock, url, index, combination, "Out Of Stock", combination?.price, sitePrice);
        }
      }
      else {
        addToExData = data
        let prevStock = approvedProductsList[index]?.vendors?.[0]?.stock || 0
        let stockStatus = (Number(stock) > 0) ? "In Stock" : "Out Of Stock"
        sitePrice = approvedProductsList[index]?.specialPrice ? approvedProductsList[index]?.specialPrice : approvedProductsList[index]?.price;
        (Number(stock) === 0 || Number(prevStock) < 1) && await handleSaveVendorStock(id, stock, url, index, combination, stockStatus, approvedProductsList[index]?.vendors?.[0]?.purchase_price, sitePrice);
      }

      // Only call addToExProduct if saveVendorStock succeeded
      api.product.addToExProduct(addToExData).then((res) => {
        alert.success("Stock Updated Successfully!")
        // Action Required Products
        setselectedPage(1)
        if(noRefresh) return;
       globalFilter = {
          pageNo: 1,
          prStatus: {
            $or: [
              {
                //SL-968
                //prSts: "V_PENDING",
                $and: [
                  //{ combination: { $exists: false, $size: 0  } },
                  {
                    $or: [
                      { combination: { $exists: false } },
                      { combination: { $size: 0 } }
                    ]
                  },
                  { prSts: "V_PENDING" }
                ]
              },
              {
                combination: {
                  $elemMatch: {
                    purchase_price: { $exists: true, $ne: null },
                    prSts: "V_PENDING"
                  }
                }
                /*$and : [
                  { combination: { $exists: true, $ne: [] } },
                  { "combination.purchase_price" : { $exists: true, $ne: null }},
                  { "combination.prSts": "V_PENDING" },
                ]*/
              },
            ],
          },
          //No need to show product's in which vendor's active = false | Ticket : SL-968
          /*status: {
            active: false,
          },*/
          //Need to remove weight verification products | Ticket : SL-986
          /*weightStatus: {
            $or: [
              {
                sellerWeightChangeSts: "V_PENDING",
              },
              {
                "combination.sellerWeightChangeSts": "V_PENDING",
              },
            ],
          },*/
        };
        //SL-968
        api.product.productsRetrieveall(actionRequiredFilter(globalFilter))
          .then((res) => {
            const sortedProducts = priceSortOrder
              ? sortProductsByPrice(res.products, priceSortOrder)
              : res.products;
            setapprovedProductsList(sortedProducts)
            setappRecords(res.totalRecords)
            handleCloseoffcan()
          })
          .catch(err => console.log(err))


      }).catch(err => console.log(err))
    } catch (err) {
      // If saveVendorStock failed, don't call addToExProduct
      console.log("Stock update aborted due to vendor stock error:", err)
    }

  }

  // l1-2341 (10-9-25)
  const handleSaveVendorStock = async (id, stock, url, index, combination, stockStatus, price, site_price) => {
    try {
      let data = {
        "product": approvedProductsList[index]?._id,
        "vendor": approvedProductsList[index]?.vendors?.[0]?.vendor_id,
        "taxClass": approvedProductsList[index]?.vendors?.[0]?.taxClass,
        "purchase_price": price,
        "stock": stock,
        "status": "AUTOAPPROVED",
        "stockStatus": stockStatus,
        "site_price": site_price,
        "categories": approvedProductsList[index]?.categories,
        "receivedFrom": "seller"
      }
      if (url) {
        data["combination.url"] = combination?.url
      }
      await saveVendorStock(data)
    } catch (err) {
      console.log(err)
      alert.error(err.message || "Failed to update stock status");
      // Re-throw the error so the calling function knows it failed
      throw err;
    }

  }

  // l1-2319 (2-9-26)
  async function updateProductHSN(id, hsn) {
    let data = {
      "_id": id,
      "HSN": hsn
    }
    try {

      let res = await api.product.addToExProduct(data);
      if (
        res.message === "product updated" ||
        res.message === "product added") {
        ApiCalling();
        alert.success("HSN Updated Successfully!");
      }
      else {
        alert.info(res.message);
      }
    }
    catch (err) {
      alert.info("Failed to update HSN");
      console.log(err);
    }
  }


  const ApiCalling = () => {
    if (globalFilter?.searchIds)
      delete globalFilter['searchIds'];
    // clear product filter
    if (globalFilter['product']){
      delete globalFilter['product'];
    }
    globalFilter.pageNo = selectedPage;
    getProducts(1);
    //SL-968
    //api.product.productsRetrieveall(approvedOrProducts(globalFilter))
    // api.product.productsRetrieveall(actionRequiredFilter(globalFilter))
    //   .then((res) => {
    //     const sortedProducts = priceSortOrder
    //       ? sortProductsByPrice(res.products, priceSortOrder)
    //       : res.products;
    //     setapprovedProductsList(sortedProducts);
    //     setappRecords(res.totalRecords);
    //     Actions.InventoryCountUpdateAction(dispatch, { actionRequired: res.totalRecords });
    //     if (res.totalRecords === 0 && isNoFilterApplied()) {
    //       setloaderProduct("none");
    //       history.replace("/my-inventory/approved/all-products");
    //       return;
    //     }
    //     setloaderProduct("none");
    //   })
    //   .catch((err) => {
    //     setloaderProduct("none");
    //     console.log(err);
    //   });
  }

  /**
  * Search By Keyword On Enter
  */
  const searchByKeyword = (value, type, productIds) => {

    if (productIds.length > 0) {
      globalFilter['product'] = {$in: productIds};
      //Search Issue on Other than 1st Page SL-698 and SL-675
      globalFilter.pageNo = 1;

      setselectedPage(1)

      // if (priceSortOrder) {
      //   globalFilter["priceSort"] = priceSortOrder;
      // }
      //SL-968
      //api.product.productsRetrieveall(approvedOrProducts(globalFilter))
      api.product.vPriceReqRetrieveAll(getVPriceReqsFilter(globalFilter))
        .then((res) => {
          // const sortedProducts = priceSortOrder
          //   ? sortProductsByPrice(res.products, priceSortOrder)
          //   : res.products;
          setapprovedProductsList(res.data);
          setappRecords(res.totalRecords);
           if (updateSearchCountRef.current) {
          updateSearchCountRef.current(res.totalRecords);
        }
          setloaderProduct("none");
        })
        .catch((err) => {
          setloaderProduct("none");
          console.log(err);
        });

    }
    else {
      setappRecords(0);
      setapprovedProductsList([]);
       if (updateSearchCountRef.current) {
      updateSearchCountRef.current(0);
    }
    }
  }

  // HSN Filter handler
  const handleHSNFilterChange = (hsnFilter) => {
    if (hsnFilter) {
      globalFilter = {
        ...globalFilter,
        hsnFilter: hsnFilter
      };
    } else {
      // Remove hsnFilter from globalFilter
      const { hsnFilter, ...filterWithoutHSN } = globalFilter;
      globalFilter = filterWithoutHSN;
    }
    globalFilter.pageNo = 1;
    setselectedPage(1);
    // Add price sorting if active
    if (priceSortOrder) {
      globalFilter["priceSort"] = priceSortOrder;
    }
    // Call API and update count
  api.product.productsRetrieveall(actionRequiredFilter(globalFilter))
    .then((res) => {
      setapprovedProductsList(res.products);
      setappRecords(res.totalRecords);
      
      // ✅ Update the search component's count display if HSN filter is active
      if (updateSearchCountRef.current && hsnFilter) {
        updateSearchCountRef.current(res.totalRecords);
      }
      
      setloaderProduct("none");
    })
    .catch((err) => {
      setloaderProduct("none");
      console.log(err);
    });
    //ApiCalling();
  }

  // Clear All Filters handler
  const clearAllFilters = () => {
    // Clear search
    setsearchPro("");

    // Clear HSN filter without calling API
    const { hsnFilter, ...filterWithoutHSN } = globalFilter;
    globalFilter = filterWithoutHSN;

    // Reset search type to Product Name
    setResetSearchType(prev => prev + 1);

    // Reset global filter to initial state
    globalFilter = {
      pageNo: 1,
      prStatus: {
        $or: [
          {
            prSts: "V_PENDING",
          },
          {
            prSts: "PENDING",
          },
        ],
      },
      status: {
        active: false,
      },
    };
    setselectedPage(1);

    // Call API only once at the end
    ApiCalling();
  }

  // Sl-906
  const handlePriceChange = ({ isCombination, lead, url, price, gst }) => {
    setCurPricePopupLead(lead);
    setCurPricePopupUrl(url);
    setCurPricePopupPrice(price);
    setCurPricePopupGst(gst);
    setNewPricePopupShow(true);
    setCurPricePopupCombState(isCombination);
  }

  const handleCallBackSuccessStatus = (callBackSuccess) => {
    if (callBackSuccess) {
      ApiCalling()
    }
  }

  //<Start-Here> Refresh After Bulk Upload | Ticket : SL-943
  /**
   * Refresh the page
   */
  const refreshAfterBulkUpload = () => {
    applyLoader();
    globalFilter.pageNo = 1;
    setselectedPage(1);
    // Action required Products
    api.product
      //SL-968
      //.productsRetrieveall(approvedOrProducts(globalFilter))
      .productsRetrieveall(actionRequiredFilter(globalFilter))
      .then((res) => {
        const sortedProducts = priceSortOrder
          ? sortProductsByPrice(res.products, priceSortOrder)
          : res.products;
        setapprovedProductsList(sortedProducts);
        setappRecords(res.totalRecords);
        removeLoader();
      })
      .catch((err) => {
        console.log(err);
        removeLoader();
      });
  }
  //</End-Here> Refresh After Bulk Upload | Ticket : SL-943

  const handleCountUpdate = (updateFn) => {
  updateSearchCountRef.current = updateFn;
};

  return (
    <>
      <div className="inventry-page" id="outer">
        <div className="d-flex inv_filter_cntn">
          {/* <button className={removeFilterClass} onClick={() => clearFilters()}>
            Clear Filter
          </button> */}
          <div className='topprodsearch d-flex align-items-center'>
            <ProductSKUSearch
              filterSearch={filterSearch}
              searchNewEnq={setsearchPro}
              searchParam={searchParam}
              from={"priceReq"}
              flag="Product"
              apiCall={ApiCalling}
              totalRcordId={totalRcordId}
              searchByKeyword={searchByKeyword}
              // onHSNFilterChange={handleHSNFilterChange}
              resetSearchType={resetSearchType}
              onCountUpdate={handleCountUpdate}
            />
            {/* <PriceSortDropdown
              sortOrder={priceSortOrder}
              onToggleSort={togglePriceSort}
              onClearSort={clearPriceSort}
            /> */}
          </div>
          <div>
            <BulkStockHandler />
            <NavLink exact to="/products" className="inv_tab_add_product">
              <button className="pro_add_pro_invent">+ Add Product</button>
            </NavLink>
          </div>
        </div>

        <div className="container_invent" id="orDeskContain">

         {selectedIds?.length > 0 &&
          <div className="selected-bar">
              <div className="selected-info">
                <span className="selected-count">{selectedIds.length}</span>
                <span className="selected-text">selected</span>
                <button className="clear-btn" onClick={() => setSelectedIds([])}>Clear</button>
              </div>

              <div className="selected-actions">
                <button className="reject-btn" onClick={() => handleUpdatePriceBulkReq("V_REJECT")}>
                  <span>×</span>
                  Reject selected
                </button>

                <button className="accept-btn" onClick={() => handleUpdatePriceBulkReq("V_ACTIVE")}>
                  <span>✓</span>
                  Accept selected
                </button>
              </div>
            </div>
          }

          {/* New orders desktop */}
          <div class="tab table-responsive">
            {/* <Container> */}

            {/* <table className="ord_table new-table-design" style={{ width: "100%", tableLayout: "fixed" }}> */}
            <table className="new-table-design priceReq-table">
              <thead>
                <tr className="table_ord_title_row">
                  {/* Checkbox */}
                  <th className="product-checkbox">
                    <input
                      type="checkbox"
                      checked={
                        approvedProductsList?.length > 0 &&
                        selectedIds.length === approvedProductsList?.length
                      }
                      onChange={(e) => handleSelectAll(e.target.checked)}
                    />
                  </th>
                  <th className="thead_title pb-1">
                    PRODUCTS DETAILS
                  </th>

                  <th className="thead_title">
                    TRANSFER PRICE 
                  </th>

                  <th className="thead_title">
                    REQUESTED DATE 
                  </th>
                  <th className="thead_title">
                    ACTIONS
                  </th>
                </tr>
              </thead>
              <tbody>
                {appRecords > 0 ? (
                  approvedProductsList.map((item, index) => {
                    let baseImg;
                    let lowestPrice = undefined;
                    const product = item.product;
                    let taxClass = product?.vendors?.taxClass || '18';
                    product?.images?.map((item) => {
                      if (item.baseImage === true) {
                        if (item.image.startsWith("products")) {
                          baseImg = item.image;
                        } else if (item.image.startsWith("mob")) {
                          baseImg = item.image;
                        } else {
                          let img = item.image.substr("41");
                          baseImg = img;
                        }
                      }
                    });
                    // if (
                    //   item.vendors[0] &&
                    //   item.vendors[0].taxClass &&
                    //   item.vendors[0].taxClass !== ""
                    // ) {
                    //   taxClass = item.vendors[0].taxClass;
                    // } else {
                    //   taxClass = item.taxClass;
                    // }
                    let date = new Date(item.createdAt);
                    let d = date.toUTCString(item.createdAt);
                    let newd = d.substr(4, 12);

                    // check if price request for attribute product
                    let currentPrice = item?.old_price;
                    let comb = "";
                    if (item.url) {
                      product.combination.map((pitem, pindex) => {
                        if (
                          pitem.url === item.url
                        ) {
                          pitem.value.map((aitem, aindex) => {
                            comb = comb + aitem;
                            if (aindex !== pitem.value.length - 1) {
                              comb = comb + " x ";
                            }
                          });
                        }
                      });
                      if (!currentPrice && product?.vendor?.combination?.length > 0) {
                        product.vendor.combination.map((vitem, vindex) => {
                          if (
                            vitem.url === item.url
                          ) {
                            currentPrice = vitem.purchase_price;
                          }
                        })
                      }

                    } else {
                      if (!currentPrice) {
                        currentPrice = product?.vendor?.purchase_price;
                      }
                    }
                    return (
                      <ProductCardNewDesign
                          id={index}
                          taxClass={taxClass}
                          productId={product?._id}
                          SKU={product?.SKU}
                          updatedon={newd}
                          comb={comb !== ""? comb: ""}
                          url={item?.url}
                          lead={item._id}
                          productName={product?.productName}
                          newPrice={item?.price}
                          currentPrice={currentPrice}
                          handleUpdatePriceReq={handleUpdatePriceReq}
                          image={baseImg}
                          selectedIds={selectedIds}
                          onSelectItem={handleSelectItem}
                          onReject={handleOnReject}
                          // tabType="priceReq"
                          // handlePriceRequest={handlePriceChange}
                          // callbackGetProducts={callbackResUpdate}
                          // getProducts={getProducts}
                        />
                      );
                    // if (item.combination) {
                    //   let vendorfirstComb = [];

                    //   if (item.vendors[0].combination.length > 0) {
                    //     var offerArry = [];
                    //     var combarry = [];
                    //     var singleAttr = true;
                    //     if (
                    //       item.combination[0] &&
                    //       item.combination[0].value &&
                    //       item.combination[0].value.length > 1
                    //     ) {
                    //       singleAttr = false;
                    //     }
                    //     item.vendors[0].combination.map((vitem, vindex) => {
                    //       item.combination.map((pitem, pindex) => {
                    //         if (
                    //           pitem.url === vitem.url &&
                    //           vitem.purchase_price &&
                    //           vitem.purchase_price !== undefined &&
                    //           pitem.active
                    //         ) {
                    //           // if (vindex === 0) {
                    //           //     if (pitem.lowestPrice < vitem.purchase_price)
                    //           //         lowestPrice = pitem.lowestPrice
                    //           // }
                    //           if (!singleAttr) {
                    //             let com = "";

                    //             pitem.value.map((aitem, aindex) => {
                    //               com = com + aitem;
                    //               if (aindex !== pitem.value.length - 1) {
                    //                 com = com + " x ";
                    //               }
                    //             });
                    //             combarry.push({
                    //               com: com,
                    //               price: vitem.purchase_price,
                    //               lowestPrice: pitem.lowestPrice,
                    //               status:
                    //                 vitem.vActive === "ACTIVE" ||
                    //                   vitem.vActive === "INACTIVE_REQ"
                    //                   ? "In Stock"
                    //                   : "Out of Stock",
                    //               url: vitem.url,
                    //               inventoryStock: pitem.inventoryStock,
                    //               stock: vitem?.stock,
                    //               prSts: vitem?.prSts,
                    //               "sellerWeightChangeSts": vitem?.sellerWeightChangeSts
                    //             });
                    //             if (
                    //               vitem.prSts &&
                    //               vitem.prSts === "V_PENDING"
                    //             ) {
                    //               let cmb = "";
                    //               pitem.value.map((litem, lindex) => {
                    //                 cmb = cmb + litem;
                    //                 if (lindex !== pitem.value.length - 1) {
                    //                   cmb = cmb + " x ";
                    //                 }
                    //               });
                    //               offerArry.push({ cmb: cmb, url: vitem.url });
                    //             }
                    //           } else {
                    //             let com = {
                    //               com: pitem.value[0],
                    //               price: vitem.purchase_price,
                    //               lowestPrice: pitem.lowestPrice,
                    //               status:
                    //                 vitem.vActive === "ACTIVE" ||
                    //                   vitem.vActive === "INACTIVE_REQ"
                    //                   ? "In Stock"
                    //                   : "Out of Stock",
                    //               url: vitem.url,
                    //               inventoryStock: pitem.inventoryStock,
                    //               stock: vitem?.stock,
                    //               prSts: vitem?.prSts,
                    //               "sellerWeightChangeSts": vitem?.sellerWeightChangeSts
                    //             };
                    //             combarry.push(com);
                    //             if (
                    //               vitem.prSts &&
                    //               vitem.prSts === "V_PENDING"
                    //             ) {
                    //               offerArry.push({
                    //                 cmb: pitem.value[0],
                    //                 url: vitem.url,
                    //               });
                    //             }
                    //           }
                    //         }
                    //       });
                    //     });
                    //     return (
                    //       <ProductCardNewDesign
                    //         id={index}
                    //         inventoryStock={item.inventoryStock}
                    //         taxClass={taxClass}
                    //         SKU={item.SKU}
                    //         updatedon={newd}
                    //         urlKey={item.urlKey}
                    //         showButton={true}
                    //         //SL-975
                    //         //status={item.vendors[0].vActive}
                    //         status={item.vendors[0]?.combination[0]?.stock > 0 ? 'ACTIVE' : 'INACTIVE'}
                    //         // lowestPrice={lowestPrice}
                    //         shortDescription={item.shortDescription}
                    //         lead={item._id}
                    //         productName={item.productName}
                    //         //SL-975
                    //         //quantity={item.vendors[0].stock}
                    //         quantity={item.vendors[0]?.combination[0]?.stock}
                    //         weight={item.vendors[0].weight}
                    //         requestFrom="inventory"
                    //         offerForArr={offerArry}
                    //         vendActive={item.vendors[0].active}
                    //         callback={productCheck}
                    //         image={baseImg}
                    //         vendor={item.vendors[0]}
                    //         verTransPrice={verifyTransferPrice}
                    //         vendorfirstComb={vendorfirstComb}
                    //         combination={combarry}
                    //         changeproductStatusFun={changeproductStatus}
                    //         popupVisibility={setpopupVisibility}
                    //         fun={henfun}
                    //         showWeightMsg={true}
                    //         showPriceMsg={true}
                    //         tabType="actionReq"
                    //         updateSellerStock={updateSellerStock} //Update Seller Stock
                    //         // l1-2319 (2-9-26)
                    //         hsn={item?.vendors?.[0]?.HSN || ''}
                    //         updateProductHSN={updateProductHSN}
                    //         handlePriceRequest={handlePriceChange}
                    //         callbackGetProducts={callbackResUpdate}
                    //         getProducts={getProducts}
                    //         refreshProducts={callbackResUpdate}
                    //       />
                    //     );
                    //   } else {
                    //     return (
                    //       <ProductCardNewDesign
                    //         id={index}
                    //         inventoryStock={item.inventoryStock}
                    //         taxClass={taxClass}
                    //         SKU={item.SKU}
                    //         updatedon={newd}
                    //         urlKey={item.urlKey}
                    //         lowestPrice={item.lowestPrice}
                    //         shortDescription={item.shortDescription}
                    //         lead={item._id}
                    //         showButton={true}
                    //         verTransPrice={verifyTransferPrice}
                    //         productName={item.productName}
                    //         price={item.vendors[0].purchase_price}
                    //         quantity={item.vendors[0].stock}
                    //         //SL-975
                    //         //status={item.vendors[0].vActive}
                    //         status={item.vendors[0]?.stock > 0 ? 'ACTIVE' : 'INACTIVE'}
                    //         vendActive={item.vendors[0].active}
                    //         vendor={item.vendors[0]}
                    //         weight={item.vendors[0].weight}
                    //         requestFrom="inventory"
                    //         callback={productCheck}
                    //         image={baseImg}
                    //         combination={combarry}
                    //         changeproductStatusFun={changeproductStatus}
                    //         popupVisibility={setpopupVisibility}
                    //         fun={henfun}
                    //         showWeightMsg={true}
                    //         showPriceMsg={true}
                    //         tabType="actionReq"
                    //         updateSellerStock={updateSellerStock} //Update Seller Stock
                    //         // l1-2319 (2-9-26)
                    //         hsn={item?.vendors?.[0]?.HSN || ''}
                    //         updateProductHSN={updateProductHSN}
                    //         handlePriceRequest={handlePriceChange}
                    //         callbackGetProducts={callbackResUpdate}
                    //         getProducts={getProducts}
                    //         refreshProducts={callbackResUpdate}
                    //       />
                    //     );
                    //   }
                    // } else {
                    //   return (
                    //     <ProductCardNewDesign
                    //       id={index}
                    //       inventoryStock={item.inventoryStock}
                    //       taxClass={taxClass}
                    //       SKU={item.SKU}
                    //       updatedon={newd}
                    //       urlKey={item.urlKey}
                    //       verTransPrice={verifyTransferPrice}
                    //       lowestPrice={item.lowestPrice}
                    //       shortDescription={item.shortDescription}
                    //       lead={item._id}
                    //       showButton={true}
                    //       productName={item.productName}
                    //       price={item.vendors[0].purchase_price}
                    //       vendor={item.vendors[0]}
                    //       quantity={item.vendors[0].stock}
                    //       //SL-975
                    //       //status={item.vendors[0].vActive}
                    //       status={item.vendors[0]?.stock > 0 ? 'ACTIVE' : 'INACTIVE'}
                    //       weight={item.vendors[0].weight}
                    //       vendActive={item.vendors[0].active}
                    //       requestFrom="inventory"
                    //       callback={productCheck}
                    //       image={baseImg}
                    //       changeproductStatusFun={changeproductStatus}
                    //       popupVisibility={setpopupVisibility}
                    //       fun={henfun}
                    //       showWeightMsg={true}
                    //       showPriceMsg={true}
                    //       tabType="actionReq"
                    //       updateSellerStock={updateSellerStock} //Update Seller Stock
                    //       // l1-2319 (2-9-26)
                    //       hsn={item?.vendors?.[0]?.HSN || ''}
                    //       updateProductHSN={updateProductHSN}
                    //       handlePriceRequest={handlePriceChange}
                    //       callbackGetProducts={callbackResUpdate}
                    //       getProducts={getProducts}
                    //     />
                    //   );
                    // }
                  })
                ) : loaderProduct === "block" ? (
                  <></>
                ) : (
                  <></>
                )}
                {loaderProduct === "none" && approvedProductsList.length === 0 && (
                  <tr>
                    <td colSpan={6} style={{ textAlign: 'center', padding: '1rem' }}>
                      No record found!
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            {/* </Container> */}
          </div>

          <PaginationNew
            number={appRecords}
            paginate={paginate}
            activ={selectedPage}
            comp={compforPaginationweb}
          />

          <div class="d-flex justify-content-center loader-bt" id="enNewLoader">
            <div
              class="spinner-border"
              role="status"
              style={{ display: loaderProduct }}
            >
              <span class="sr-only"></span>
            </div>
          </div>
        </div>

        {/* {approvedProductsList.length > 0 ? (
          <div
            id="popup1"
            className="overlay"
            style={{ display: isPopupVisible }}
          >
            <Popup
              name={approvedProductsList[currDetail].productName}
              price={null}
              SKU={approvedProductsList[currDetail].SKU}
              popupVisibility={setpopupVisibility}
              images={approvedProductsList[currDetail].images}
              description={approvedProductsList[currDetail].description}
              sdescription={approvedProductsList[currDetail].shortDescription}
              descriptionNew={approvedProductsList[currDetail].descriptionNew}
              specificationNew={approvedProductsList[currDetail].specificationNew}

              callback={productCheck}
              lead={approvedProductsList[currDetail]._id}
            />
          </div>
        ) : (
          <></>
        )} */}

        {updtProVisibility === true && combAttri.length > 0 && (
          <UpdtProPopup2
            lead={clickedUpdateNo}
            productName={selectedProductPopup}
            callbackResFun={callbackResUpdate}
            combattr={combAttri}
            img={selectedImgPopup}
            product={currentProupdt}
            detail={updtPopuprel}
            Popupvisible="block"
            from="approved-Pro"
            Popupvisibilityfun={checkpopupvisibility}
          />
        )}
        {updtProVisibility === true && combAttri.length < 1 && (
          <UpdtProPopup2
            lead={clickedUpdateNo}
            img={selectedImgPopup}
            productName={selectedProductPopup}
            detail={updtPopuprel}
            callbackResFun={callbackResUpdate}
            Popupvisible="block"
            from="approved-Pro"
            Popupvisibilityfun={checkpopupvisibility}
          />
        )}
        {/* Off canvas for verify transfer price */}

        <Offcanvas
          show={offcanshow}
          onHide={handleCloseoffcan}
          placement="bottom"
          className="h-40 offcan_transfer_price"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title className="m-auto">
              Verify Transfer Price
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body className="m-0 p-0">
            {offcanstate === "ask" ? (
              <Container>
                <Card className=" mb-2 theme-outline  ">
                  <p className="theme-col px-3 pt-2 pb-0 f-600 fs-14 curr_trans_p text-center">
                    Current Transfer Price (incl. {taxClass}% GST) :
                    <span className="f-600 fs-13 ms-1 mt-1 text-black ff_pop">
                      {" "}
                      <i className="fa fa-inr"></i> {curroffCanPrice}{" "}
                    </span>
                  </p>
                  {curroffCanPrice > lowestPrice ? (
                    <p className="px-3 pt-2 pb-0 f-600 fs-11 text-center">
                      <span className="text-warning fs-17">
                        <i className="bi bi-exclamation-triangle-fill"></i>
                      </span>
                      <span className="other_seller_price">
                        {" "}
                        Other seller's price(incl. GST) :
                      </span>
                      <span className="f-600 fs-13 ms-1 mt-1 text-primary">
                        {" "}
                        <i className="fa fa-inr"></i> {lowestPrice}{" "}
                      </span>
                    </p>
                  ) : (
                    <></>
                  )}
                  <p className="iscorr_trans_p text-center fs-14">
                    Is this the correct price{" "}
                    <i class="fa fa-question" aria-hidden="true"></i>
                  </p>

                  <Row className="text-center my-3 ">
                    <div className="col-6 pt-1">
                      <button
                        className="yes-button1 offcan_yes_button"
                        onClick={() => yesVerifyPrice()}
                      >
                        Yes
                      </button>
                    </div>
                    <div className="col-6 pt-1">
                      <button
                        className="yes-button1 offcan_no_button"
                        onClick={() => noVerifyPrice()}
                      >
                        No
                      </button>
                    </div>
                  </Row>
                </Card>
              </Container>
            ) : offcanstate === "askNewPrice" ? (
              <Container>
                <Card className=" mb-2 theme-outline  ">
                  <p className="theme-col px-3 pt-2 pb-0 f-600 fs-14 curr_trans_p text-center">
                    Current Transfer Price (incl. {taxClass}% GST) :
                    <span className="f-600 fs-13 ms-1 mt-1 text-black ff_pop">
                      {" "}
                      <i className="fa fa-inr"></i> {curroffCanPrice}{" "}
                    </span>
                  </p>
                  <p className="text-center fs-14 iscorr_trans_p">
                    Please Enter New Transfer Price (Incl. GST) :
                  </p>
                  <div className="text-center">
                    <i className="fa fa-inr me-2"></i>
                    <input
                      type="number"
                      onChange={(e) => setnewoffcanPrice(e.target.value)}
                      onWheel={(e) => e.target.blur()}
                      className="inr-input pl-1"
                    ></input>
                  </div>
                  <Row className="text-center my-3 ">
                    <div className="col-12 pt-1">
                      <button
                        className="yes-button1 ff_pop"
                        onClick={() => checkNewPrice()}
                      >
                        Submit
                      </button>
                    </div>
                  </Row>
                </Card>
              </Container>
            ) : (
              <Container>
                <Card className=" mb-2 theme-outline  ">
                  <p className="new_req_price_head text-center pt-3 pb-0">
                    New Requested Transfer Price:
                    <span className="f-600 fs-17 ms-1 mt-1 text-black">
                      {" "}
                      <i className="fa fa-inr"></i> {newoffcanPrice}{" "}
                    </span>
                  </p>
                  <span className="text-red fs-12 px-3 pb-2 f-700 note_trans_price">
                    Note : It will take 48 to 72 hrs for our team to verify your
                    new transfer price request. Meanwhile you can -
                  </span>
                  {/* <div className="text-center"><i className="fa fa-inr me-2"></i><input  type="number" className="inr-input"></input></div> */}
                  <div
                    onChange={(e) => setseloption(e.target.value)}
                    className="px-4"
                  >
                    <input
                      type="radio"
                      id="vehicle1"
                      className="input-chk"
                      name="opt"
                      value="continueSame"
                      defaultChecked
                    />
                    <label className="theme-col fs-13 mx-2 f-500 new_req_price_head">
                      {" "}
                      Continue selling with the current price
                    </label>
                    <br></br>
                    <input
                      type="radio"
                      id="vehicle2"
                      name="opt"
                      className="input-chk"
                      value="makeInactive"
                    />
                    <label className="theme-col fs-13 mx-2 f-500 new_req_price_head">
                      {" "}
                      Make it inactive
                    </label>
                    <br></br>

                    <div className="text-right mb-2">
                      <input
                        type="submit"
                        id="sub_newreq"
                        className="yes-button1 "
                        onClick={() => newPriceReq()}
                      />
                    </div>
                  </div>
                </Card>
              </Container>
            )}
          </Offcanvas.Body>
        </Offcanvas>
      </div>
      {/* Toast */}
      <Toast
        show={showToast}
        className="ToastHome"
        onClose={() => setshowToast(false)}
      >
        <Toast.Header>
          <strong className="me-auto">Message</strong>
        </Toast.Header>
        <Toast.Body>{ToastMsg}</Toast.Body>
      </Toast>

      {/* Filter Modal */}


      {/* SL-906 */}
      <NewPriceReqPopup
        offcanshow={newPricePopupShow}
        handleCloseoffcan={() => setNewPricePopupShow(false)}
        lead={curPricePopupLead}
        url={curPricePopupUrl}
        pPrice={curPricePopupPrice}
        currGst={curPricePopupGst}
        isCombination={curPricePopupCombState}
        handleCallBackSuccessStatus={handleCallBackSuccessStatus}
        receivedFrom="Inventory"
      />

      {/* Reject price resubmit */}
      <RejectPriceResubmit
        show={showPriceOfferPopup}
        onHide={() => setShowPriceOfferPopup(false)}
        productData={selectedProductData}
        // onYes={handlePriceOfferYes}
        // onNo={handlePriceOfferNo}
        onNewPriceSubmit={handleNewPriceSubmit}
        // closeNotificationAndRefresh={closeNotificationAndRefresh}
      />
    </>
  );
}

export default PriceChangeRequest;